import { useState } from 'react';
import { auth, db } from '../firebase-config';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import "../style/Global.css";
import "../style/SignUp.css"

function SignUp() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [role, setRole] = useState('Student');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // New loading state
    const navigate = useNavigate();

    const validatePassword = (password) => {
        return password.length >= 8 &&
            /\d/.test(password) &&
            /[A-Z]/.test(password) &&
            /[a-z]/.test(password) &&
            /[!@#$%^&*(),.?":{}|<>]/.test(password);
    };

    const signUp = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsSubmitting(true);
        
        if (!validatePassword(password)) {
            setError("Password must be at least 8 characters long and include uppercase, lowercase letters, numbers, and special characters.");
            setIsSubmitting(false);
            return;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            setIsSubmitting(false);
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            
            await sendEmailVerification(user, {
            url: `${window.location.origin}/login`, // Where to redirect after verification
            handleCodeInApp: true
            });            
            
            await setDoc(doc(db, "Users", user.uid), {
                email,
                role,
                firstName,
                lastName,
                uid: user.uid,
                emailVerified: false,
            });
            alert(`Verification email sent to ${email}. Please verify your email to complete the sign-up process.`);
            setSuccess(`Verification email sent to ${email}. Please verify...`);
            
            setFirstName('');
            setLastName('');
            setEmail('');
            setPassword('');
            setConfirmPassword('');
            
        } catch (error) {
            setError(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="signUpPage">
            <div className="leftSide">
                <img src="/Images/Image2.png" alt="login/signup" />
            </div>
            <div className="rightSide">
                <h2>Sign Up</h2>
                {error && <p className="error">{error}</p>}
                {success && <p className="success">{success}</p>}
                <form onSubmit={signUp}>
                    <div className="name-fields">
                        <input 
                            type="text" 
                            placeholder="First Name" 
                            value={firstName} 
                            onChange={(e) => setFirstName(e.target.value)} 
                            required 
                            disabled={isSubmitting}
                        />
                        <input 
                            type="text" 
                            placeholder="Last Name" 
                            value={lastName} 
                            onChange={(e) => setLastName(e.target.value)} 
                            required 
                            disabled={isSubmitting}
                        />
                    </div>
                    <input 
                        type="email" 
                        placeholder="Email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                        disabled={isSubmitting}
                    /> <br />
                    <input 
                        type="password" 
                        placeholder="Password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                        disabled={isSubmitting}
                    /> <br />
                    <input 
                        type="password" 
                        placeholder="Confirm Password" 
                        value={confirmPassword} 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        required 
                        disabled={isSubmitting}
                    /> <br />
                    <label>Select Role:</label>
                    <select 
                        value={role} 
                        onChange={(e) => setRole(e.target.value)} 
                        required
                        disabled={isSubmitting}
                    >
                        <option value="Student">Student</option>
                        <option value="Teacher">Teacher</option>
                    </select>
                    <button 
                        type="submit" 
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner"></span>
                                Processing...
                            </>
                        ) : (
                            'Sign Up'
                        )}
                    </button>
                </form>
                <button 
                    className="login-btn" 
                    onClick={() => navigate('/Login')}
                    disabled={isSubmitting}
                >
                    Already have an account?
                </button>
            </div>
        </div>
    );
}

export default SignUp;